import * as React from 'react';
import { connect } from 'react-redux';

import ImageUploader, { MEDIA_TYPES_IMAGES_OR_VIDEOS } from 'components/ImageUploader';

import { addStorySnippet } from '../../redux/actions';

import { __t, applyTranslations } from 'utils/language';

import './add-story-snippet-button.scss';

import { State } from 'types';

interface OwnProps {
  deliverableId: number // eslint-disable-line react/no-unused-prop-types
}

interface StateProps {
  canAdd: boolean
}

interface DispatchProps {
  dispatchAddSnippet: (files: Array<File>, deliverableId: number) => void
}

type Props = OwnProps & StateProps & DispatchProps;

applyTranslations(require('./add-story-snippet-button.i18n.json'));

const AddStorySnippetButton = ({
  canAdd,
  dispatchAddSnippet
}: Props) => (
  canAdd ? (
    <div className="add-story-snippet-button">
      <ImageUploader
        multiple
        mediaTypes={MEDIA_TYPES_IMAGES_OR_VIDEOS}
        button={{
          color: 'secondary',
          label: __t('add_story_snippet_button.text')
        }}
        onUpload={dispatchAddSnippet}
      />
    </div>
  ) : null
);

const mapStateTopProps = (
  { storySnippets }: State,
  { deliverableId }: OwnProps
): StateProps => ({
  canAdd: !!storySnippets.deliverables[deliverableId]?.canEdit
});

const mapDispatchToProps = (dispatch, { deliverableId }: OwnProps): DispatchProps => ({
  dispatchAddSnippet: files => dispatch(addStorySnippet([...files], deliverableId))
});

export default connect(mapStateTopProps, mapDispatchToProps)(AddStorySnippetButton);
